import { render, staticRenderFns } from "./SlotsTickets.vue?vue&type=template&id=eb52c414"
import script from "./SlotsTickets.vue?vue&type=script&lang=js"
export * from "./SlotsTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports